<div class="sections">
    <div>
        <form [formGroup]="form">
            <div class="field multiple">
                <div class="flex-fill">
                    <h4>Avg. volume per month</h4>
                    <mat-form-field appearance="outline" appFormFieldFilled>
                        <div matPrefix>$</div>
                        <input matInput
                               formControlName="avgVolumePerMonth"
                               autocomplete="off"
                               name="avoidSearch"
                               mask="separator.0"
                               thousandSeparator=","
                               separatorLimit="1000000000"
                               type="text"
                               (focus)="activeExplanationChange('avgVolumePerMonth', true)"
                               (focusout)="activeExplanationChange('avgVolumePerMonth', false)"
                               enterkeyhint="next"
                        />
                        <mat-error *ngIf="formControlError(form, 'avgVolumePerMonth') === 'required'">Avg. volume per month is required</mat-error>
                    </mat-form-field>
                </div>
                <div class="flex-fill">
                    <h4>Avg. ticket size</h4>
                    <mat-form-field appearance="outline" appFormFieldFilled>
                        <div matPrefix>$</div>
                        <input matInput
                               formControlName="avgTicketSize"
                               autocomplete="off"
                               name="avoidSearch"
                               mask="separator.0"
                               thousandSeparator=","
                               separatorLimit="1000000000"
                               type="text"
                               (focus)="activeExplanationChange('avgTicketSize', true)"
                               (focusout)="activeExplanationChange('avgTicketSize', false)"
                               enterkeyhint="next"
                        />
                        <mat-error *ngIf="formControlError(form, 'avgTicketSize') === 'required'">Avg. ticket size is required</mat-error>
                    </mat-form-field>
                </div>
                <div class="flex-fill">
                    <h4>High ticket</h4>
                    <mat-form-field appearance="outline" appFormFieldFilled>
                        <div matPrefix>$</div>
                        <input matInput
                               formControlName="highTicket"
                               autocomplete="off"
                               name="avoidSearch"
                               mask="separator.0"
                               thousandSeparator=","
                               separatorLimit="1000000000"
                               type="text"
                               (focus)="activeExplanationChange('highTicket', true)"
                               (focusout)="activeExplanationChange('highTicket', false)"
                               enterkeyhint="next"
                        />
                        <mat-error *ngIf="formControlError(form, 'highTicket') === 'required'">High ticket is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="field">
                <h4>Expected percentage of AMEX transactions</h4>
                <mat-form-field appearance="outline" appFormFieldFilled>
                    <input matInput
                           formControlName="expectedAMEXPercentage"
                           autocomplete="off"
                           name="avoidSearch"
                           (focus)="activeExplanationChange('expectedAMEXPercentage', true)"
                           (focusout)="activeExplanationChange('expectedAMEXPercentage', false)"
                           enterkeyhint="next"
                           mask="999"
                           type="number"
                           (input)="max(100, 'expectedAMEXPercentage', form)"
                    />
                    <div matSuffix>%</div>
                    <mat-error *ngIf="formControlError(form, 'expectedAMEXPercentage') === 'required'">AMEX percentage is required</mat-error>
                </mat-form-field>
            </div>
        </form>
        <div class="actions">
            <button mat-flat-button color="primary" (click)="nextClick.emit()">{{ (progress === 100) ? 'Finalize' : 'Next' }}</button>
        </div>
    </div>

    <div class="divider"></div>

    <div>
        <div class="info" #containerDiv>
            <div class="background" #backgroundDiv [ngStyle]="bgStyles"></div>

            <div class="field-explanation" #itemDiv [class.active]="activeIndex === i" *ngFor="let field of fieldExplanations; let i = index" [id]="'nuvei_app_' + field.id">
                <p>{{ field.title }}</p>
                <h4>{{ field.explanation }}</h4>
            </div>
        </div>
    </div>
</div>